import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  TextInput,
} from "react-native";
import { FontAwesome5 } from "@expo/vector-icons";
const { width, height } = Dimensions.get("window");
export default function inputfree({
  icon,
  placeholder,
  date,
  down,
  name,
  onChangeText,
  value,
}) {
  return (
    <View>
      <Text style={styles.textname}>{name}</Text>
      <TextInput
        value={value}
        style={styles.input}
        placeholder={placeholder}
        onChangeText={onChangeText}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  textname: {
    fontSize: 18,
    color: "#000000",
    marginTop: 5,
    fontFamily: "Prompt-Regular",
  },

  input: {
    width: width * 0.395,
    height: 33,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
});
